
import { InductionSection } from "../Types";

export interface NarrationSegment {
  /** Matches the id of the element shown on screen: "intro", "stat-0", "item-2" */
  id: string;
  text: string;
}

/**
 * Turns a section into the ordered list of things Sufi reads aloud:
 * her lead-in, the intro, each stat (heads, counts), then every card
 * (vision, mission, each policy and so on).
 */
export function buildSegments(section: InductionSection): NarrationSegment[] {
  const segments: NarrationSegment[] = [];

  if (section.narration) {
    segments.push({ id: "narration", text: section.narration });
  }
  if (section.intro) {
    segments.push({ id: "intro", text: section.intro });
  }
  section.stats.forEach((stat, i) => {
    segments.push({ id: `stat-${i}`, text: `${stat.label}: ${stat.value}.` });
  });
  section.items.forEach((item, i) => {
    segments.push({ id: `item-${i}`, text: `${item.label}. ${item.text}` });
  });

  return segments;
}